import axios from "axios";

async function getDataTestimonials() {
  const apiURL = "https://api-ekata.ekata.id/api/testimonials";

  return await axios
    .get(apiURL)
    .then((response) => {
      console.log("Testimonials : ", response.data.data);
      return response.data.data;
    })
    .catch((error) => {
      console.log(error);
      return [
        {
          service_id: 1,
          service_name: "NOT FOUND",
          service_url: "/",
        },
      ];
    });
}

export { getDataTestimonials };
